/* eslint-disable jest/require-hook */
import { liveScoreWidget as footballWidget } from '@sky-it-livedata/livedata-football-widgets';
import { liveScoreWidget as motorsportsWidget } from '@sky-it-livedata/livedata-motorsports-widgets';

/* Import Dynamic Components */

import DynamicFootball from './components/football/dynamic-football';
import DynamicMotorsports from './components/motorsports/dynamic-motorsports';
import { clickFromHash, hydrateMenuTabs } from './utils/hydrate-tabs-menu';
import { defineWebComponents } from './utils/web-components-utils';
import { initStickyTabs } from './utils/init-sticky-tabs';

/* Looking at the package.json, you can see that both livedata-football-widgets and livedata-motorsports-widgets are listed as dependencies. 
This means that, unlike other WebApps, here, widgets from different sports can coexist. 
*/
const webComponentsMap = new Map();
webComponentsMap.set(footballWidget.tag, DynamicFootball);
webComponentsMap.set(motorsportsWidget.tag, DynamicMotorsports);

defineWebComponents(webComponentsMap);

document.addEventListener('DOMContentLoaded', () => {
  hydrateMenuTabs();
  clickFromHash();
  initStickyTabs();
});
